import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

const PrincipalContact = (props) => {
  const { agencyFormPayload } = props || {}
  const {
    entityState: {
      principal_email,
      principal_mobile,
      principal_name,
    },
    errors,
    handlers,
  } = agencyFormPayload

  return (
    <DashboardModule title="Principal Contact">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.principal_name} label="* Name">
            <input name="principal_name" value={principal_name} type="text" {...handlers} />
          </Form.Field>

          <Form.Field errorMessage={errors.principal_mobile} label="* Mobile" marginTop={['large', 0]}>
            <input name="principal_mobile" value={principal_mobile} type="text" {...handlers} />
          </Form.Field>
        </Form.Row>

        <Form.Field errorMessage={errors.principal_email} label="* Email" marginTop="large">
          <input name="principal_email" value={principal_email} type="text" {...handlers} />
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

PrincipalContact.propTypes = {
  agencyFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      principal_email: PropTypes.string.isRequired,
      principal_mobile: PropTypes.string.isRequired,
      principal_name: PropTypes.string.isRequired,
    }),
    errors: PropTypes.object,
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default PrincipalContact
